import { Route } from 'react-router-dom';
import AuthenticatedLayout from '@components/layout/Authenticated';

import Index from '@modules/design/pages/Index'
import List from '@modules/design/pages/List'

const DesignRoutes = [

    <Route path={'/designs'}> 
        <Route index element={<Index />} />
        <Route path="list" element={<List />} />
    </Route>

]

export default DesignRoutes
